import { Badge as MuiBadge, Box as MuiBox, styled } from "@mui/material";
import { AccountMenuItemProps } from "./AccountMenuItem.props";

const AccountMenuItemRoot = styled(MuiBox, {
  shouldForwardProp: (prop) => prop !== "active"
})<Pick<AccountMenuItemProps, "active">>(
  ({
    theme: {
      palette: { custom }
    },
    active
  }) => {
    const color = active ? custom.turquoise.main : custom.white.light;

    return `
      &.MuiBox-root {
        & .MuiBadge-root {
          & .MuiButtonBase-root {
            text-transform: initial;
            font-weight: normal;
            color: ${color};

            &.active {
              color: ${custom.turquoise.main};
            }

            &:active {
              color: ${custom.white.main};
            }
          }

          & .MuiBadge-dot {
            background-color: ${custom.coral.main};
            top: 10px;
            right: 4px;
          }
        }
      }
    `;
  }
);

export const AccountMenuItem = ({
  showBadge,
  children,
  active,
  ...props
}: AccountMenuItemProps) => (
  <AccountMenuItemRoot active={active} {...props}>
    <MuiBadge variant="dot" invisible={!showBadge}>
      {children}
    </MuiBadge>
  </AccountMenuItemRoot>
);
